// extracted by mini-css-extract-plugin
export default {"cc-popbox-cheer":"UlC19IpY","cc-popbox-cheer-info":"jJ0L26nx"};